import React from 'react';
import SitebarDropdown from './sitebarDropdown';
import Badge from 'src/components/badges/badge';
import { notificationToMenuItemConfig } from 'src/utils/notificationUtil';
import i18n from 'src/utils/translate';
import styled from 'styled-components';
import { textLinkSecondary } from 'styles-js/mixins/typography';
import { LinkButton } from 'styles-js/buttons';

const MenuButton = styled(LinkButton)`
  ${textLinkSecondary};
  font-family: ${({theme}) => theme.fontFamilyTitle};
  line-height: 49px;
  padding: 0 12px;
  display: flex;
  align-items: center;

  &:focus, &:hover, &:active {
    color: ${({theme}) => theme.colorBlack};
  }
`;

const Icon = styled.span`
  margin-right: 5px;
  font-size: ${({theme}) => theme.fontSizeM};
`;

const NotificationDropdownItem = props => {
  return (
    <li>
      <a className="sitebar-dropdown__item--wrap" href={props.link}>
        <div style={{ float: 'left' }}>
          <img alt={props.username} className="avatar avatar--xsmall"
            src={props.imageUrl} />
        </div>
        <div>{props.name}</div>
      </a>
    </li>
  );
};

class NotificationsMenu extends React.Component {

  render() {
    const { open, notifications, unreadNotifications, handleClick } = this.props;

    const mappedNotificationItems = notificationToMenuItemConfig(notifications, unreadNotifications);
    return (
      <div>
        <MenuButton aria-label="Notifications" onClick={handleClick}>
          <Icon className="icon-bell-2" />
          {i18n.t('Alerts')}
          {unreadNotifications > 0 && <Badge content={unreadNotifications} type="new" />}
        </MenuButton>
        <SitebarDropdown open={open}>
          <div className="divider">{i18n.t('Notifications')}</div>
          <ul>
            {mappedNotificationItems.map((notification, index) =>
              <NotificationDropdownItem key={`item-${index}`} {...notification} />,
            )}
            <li>
              <a className="sitebar-dropdown__link" href="/notifications">
                {'+ ' + i18n.t('view all notifications')}
              </a>
            </li>
          </ul>
        </SitebarDropdown>
      </div>
    );
  }
}

export default NotificationsMenu;
